// extracted by mini-css-extract-plugin
export default {"dashboard-settings":"ManageColumns_dashboard-settings__o2CbP"};